<template>
<section class="item_box">
    <section :class="['coupon_item',item.couponType == 2?'price_coupon':'',item.couponType == 4?'discount_coupon':'',item.couponType == 3?'time_coupon':'']">
        <section class="item_left">
            <p v-if="item.couponType == 1"><span>1</span>次</p>
            <p v-if="item.couponType == 2"><span>{{item.diffAmount}}</span>元</p>
            <p v-if="item.couponType == 4"><span>{{item.diffAmount | discountT(1)}}</span><i>.{{item.diffAmount | discountT(2)}}</i>折</p>
            <p v-if="item.couponType == 3"><span>{{item.diffAmount}}</span>分钟</p>
        </section>
        <section class="item_right">
            <h2>{{item.couponName}}</h2>
            <p v-if="item.validityUnit == 1">有效期: 领券后{{item.validityTime}}分钟有效</p>
            <p v-else-if="item.validityUnit == 2">有效期: 领券后{{item.validityTime}}小时有效</p>
            <p v-else-if="item.validityUnit == 3">有效期: 领券后{{item.validityTime}}天有效</p>
            <section class="right_btns">
                <span class="btn btn_left" @click="qrDispatch(item)">二维码派券</span>
                <span class="btn btn_right" @click="cardDispatch(item)">输车牌派券</span>
            </section>
        </section>
        <p class="last_num">剩余:<span>{{item.surplusNumber}}</span></p>
    </section>
</section>
</template>
<script>
export default {
  props: {
    type: {
      type:String,
      default:'0'
    },
    item: {
      type:Object,
      default:()=>{}
    },
  },
  filters:{
    discountT(val,type){
        let num = (val/10).toFixed(1).toString();
        if(type == 1){
            return num.split(".")[0]
        }else{
            return num.split(".")[1]
        }
    }
  },
  data () {
    return {
    }
  },
  methods: {
      cardDispatch(item){
        this.$emit("cardDispatch",item)
      },
      qrDispatch(item){
        this.$emit("qrDispatch",item)
      }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.coupon_item{
    margin:0 20px;
    // overflow:hidden;
    .flex();
    padding:8px 0 32px;
    height:280px;
    box-sizing: border-box;
    position: relative;
    // box-shadow:0px 12px 20px 0px rgba(220,231,226,1);
    background:url('../../../assets/images/img_bg_coupon_green.png') left top no-repeat;
    background-size:100% 280px;
    .item_left{
        overflow: hidden;
        width:33.5%;
        border-radius:16px;
        .flex();
        justify-content: center;
        align-items: center;
        position: relative;
        .left_tips{
            display:block;
            width:100px;
            height:44px;
            background:rgba(199,239,225,1);
            border-radius:16px 0px 16px 0px;
            line-height: 44px;
            text-align: center;
            position: absolute;
            top:0;left:0;
            font-size:24px;
            color:rgba(22,188,132,1);
        }
        p{
            font-size:28px;
            color:rgba(22,188,132,1);
            line-height:40px;
            span{
                font-size:60px;
                // font-weight:bold;
                color:rgba(22,188,132,1);
                line-height:84px;
            }
        }
        .dashed{
            position: absolute;
            right:0;top:20px;
            width:2px;
            height:200px;
            border-right:2px dashed rgba(0,0,0,0.1);
        }
    }
    .item_right{
        flex:1;
        height:240px;
        border-radius:16px;
        .flex(column);
        justify-content: center;
        h2{
            font-size:30px;
            color:rgba(51,51,51,1);
            line-height:42px;
            margin-bottom:4px;
            margin-left:40px;
        }
        p{
            font-size:24px;
            color:rgba(51,51,51,0.5);
            line-height:34px;
            margin-bottom: 20px;
            margin-left:40px;
        }
        .right_btns{
            // height:68px;
            position: relative;
            .flex();
            margin-left:30px;
            .btn{
                width:204px;
                // height:68px;
                height: 92px;
                background:url('../../../assets/images/background_y.png') left top no-repeat;
                background-size:204px 92px;
                // box-shadow:0px 8px 12px 0px rgba(233,204,182,1);
                border-radius:34px 4px 4px 34px;
                text-align: center;
                line-height: 76px;
                font-size:28px;
                color:rgba(255,255,255,1);
            }
            .btn_right{
                background:url('../../../assets/images/background_blue.png') left top no-repeat;
                background-size:204px 92px;
                // box-shadow:0px 8px 12px 0px rgba(164,195,222,1);
                border-radius:4px 34px 34px 4px;
            }
            .line{
                position: absolute;
                left:182px;top:0;
                height:78px;
                width:20px;
                background:rgba(243,251,249,1);
                transform: rotate(15deg)
            }
        }
    }
    .last_num{
        position: absolute;
        top:-18px;right:0;
        width:120px;
        height:44px;
        background:rgba(252,63,86,1);
        border-radius:22px 22px 22px 0px;
        font-size:22px;
        color:rgba(255,255,255,1);
        line-height:40px;
        text-align: center;
        span{
            font-size:30px;
        }
    }
}
.price_coupon{
    background:url('../../../assets/images/img_bg_coupon_yellow.png') left top no-repeat;
    background-size:100% 280px;
    // box-shadow:0px 12px 20px 0px rgba(231,226,220,1);
    .item_left{
        .left_tips{
            color:rgba(255,155,0,1);
        }
        p{
            color:rgba(255,155,0,1);
            span{
                color:rgba(255,155,0,1);
            }
        }
    }
    .item_right{
    }
}
.discount_coupon{
    background:url('../../../assets/images/img_bg_coupon_red.png') left top no-repeat;
    background-size:100% 280px;
    .item_left{
        .left_tips{
            color:rgba(252,63,86,1);
        }
        p{
            color:rgba(252,63,86,1);
            span{
                color:rgba(252,63,86,1);
                vertical-align: -2px;
            }
            i{
                font-size:36px;
                font-style: normal;
                vertical-align: -2px;
            }
        }
    }
    .item_right{
    }
}
.time_coupon{
    background:url('../../../assets/images/img_bg_coupon_blue.png') left top no-repeat;
    background-size:100% 280px;
    .item_left{
        .left_tips{
            color:rgba(0,135,255,1);
        }
        p{
            color:rgba(0,135,255,1);
            span{
                color:rgba(0,135,255,1);
            }
        }
    }
    .item_right{
    }
}
</style>
